function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#4280c4",
    d: "M 23.5,-0.5 C 24.1667,-0.5 24.8333,-0.5 25.5,-0.5C 25.1778,5.358 25.5111,11.0247 26.5,16.5C 22.592,20.6219 22.592,24.6219 26.5,28.5C 25.1667,40.1667 25.1667,51.8333 26.5,63.5C 19.8721,65.7991 16.2054,70.4657 15.5,77.5C 18.8333,77.5 22.1667,77.5 25.5,77.5C 25.5,82.8333 25.5,88.1667 25.5,93.5C 21.8333,93.5 18.1667,93.5 14.5,93.5C 14.5,79.1667 14.5,64.8333 14.5,50.5C 17.1766,48.5399 20.1766,47.0399 23.5,46C 20.1019,44.6429 17.1019,42.8096 14.5,40.5C 14.5,28.8333 14.5,17.1667 14.5,5.5C 17.0177,2.74361 20.0177,0.743612 23.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#4279c4",
    d: "M 25.5,-0.5 C 29.8333,-0.5 34.1667,-0.5 38.5,-0.5C 40.5,0.833333 42.5,2.16667 44.5,3.5C 44.5,16.5 44.5,29.5 44.5,42.5C 42.5073,44.1632 40.1739,45.3299 37.5,46C 40.0691,46.8984 42.4024,48.065 44.5,49.5C 44.5,56.5 44.5,63.5 44.5,70.5C 39.9933,64.244 33.9933,61.9107 26.5,63.5C 25.1667,51.8333 25.1667,40.1667 26.5,28.5C 32.4258,31.3764 36.4258,29.5431 38.5,23C 36.5684,16.8691 32.5684,14.7025 26.5,16.5C 25.5111,11.0247 25.1778,5.358 25.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#4730c5",
    d: "M 160.5,0.5 C 160.5,0.166667 160.5,-0.166667 160.5,-0.5C 163.5,-0.5 166.5,-0.5 169.5,-0.5C 169.5,4.83333 169.5,10.1667 169.5,15.5C 166.281,15.7759 163.615,17.1093 161.5,19.5C 161.823,12.9779 161.49,6.6446 160.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.952
    },
    fill: "#4e2fc4",
    d: "M 169.5,-0.5 C 171.5,-0.5 173.5,-0.5 175.5,-0.5C 177.261,0.312714 178.928,1.31271 180.5,2.5C 179.504,15.9898 179.171,29.6565 179.5,43.5C 178.4,44.5585 177.066,45.3918 175.5,46C 177.315,46.7568 178.981,47.5902 180.5,48.5C 179.51,54.6446 179.177,60.9779 179.5,67.5C 176.73,64.7814 173.396,63.1148 169.5,62.5C 169.5,51.8333 169.5,41.1667 169.5,30.5C 175.176,28.1384 176.676,24.1384 174,18.5C 172.729,17.1175 171.229,16.1175 169.5,15.5C 169.5,10.1667 169.5,4.83333 169.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#4232c5",
    d: "M 160.5,0.5 C 161.49,6.6446 161.823,12.9779 161.5,19.5C 160.167,21.8333 160.167,24.1667 161.5,26.5C 161.791,32.923 161.458,39.2564 160.5,45.5C 156.63,44.7367 153.63,42.7367 151.5,39.5C 151.5,28.5 151.5,17.5 151.5,6.5C 153.63,3.26332 156.63,1.26332 160.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#542dc4",
    d: "M 180.5,2.5 C 186.002,5.17214 189.335,9.50548 190.5,15.5C 189.167,20.5 189.167,25.5 190.5,30.5C 189.35,36.9821 185.683,41.3155 179.5,43.5C 179.171,29.6565 179.504,15.9898 180.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.925
    },
    fill: "#4174c5",
    d: "M 44.5,3.5 C 53.2782,9.99202 56.4449,18.6587 54,29.5C 52.5445,35.1168 49.3778,39.4502 44.5,42.5C 44.5,29.5 44.5,16.5 44.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.895
    },
    fill: "#4484c3",
    d: "M 14.5,5.5 C 14.5,17.1667 14.5,28.8333 14.5,40.5C 6.66178,32.4614 4.82844,23.1281 9,12.5C 10.371,9.7339 12.2043,7.40057 14.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.895
    },
    fill: "#3c33c5",
    d: "M 151.5,6.5 C 151.5,17.5 151.5,28.5 151.5,39.5C 146.368,35.2927 144.035,29.7927 144.5,23C 144.035,16.2073 146.368,10.7073 151.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#3e61c7",
    d: "M 89.5,13.5 C 89.5,19.1667 89.5,24.8333 89.5,30.5C 87.7839,30.6287 86.1172,30.962 84.5,31.5C 84.5,25.8333 84.5,20.1667 84.5,14.5C 86.1172,13.962 87.7839,13.6287 89.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#3d60c8",
    d: "M 89.5,13.5 C 91.5,13.5 93.5,13.5 95.5,13.5C 95.5,18.8333 95.5,24.1667 95.5,29.5C 93.5648,30.1495 91.5648,30.4828 89.5,30.5C 89.5,24.8333 89.5,19.1667 89.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#3d5cc8",
    d: "M 95.5,13.5 C 97.8333,13.5 100.167,13.5 102.5,13.5C 102.5,18.8333 102.5,24.1667 102.5,29.5C 100.167,29.5 97.8333,29.5 95.5,29.5C 95.5,24.1667 95.5,18.8333 95.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#3b56c8",
    d: "M 102.5,13.5 C 103.833,13.5 105.167,13.5 106.5,13.5C 106.5,19.1667 106.5,24.8333 106.5,30.5C 105.292,29.7659 103.959,29.4326 102.5,29.5C 102.5,24.1667 102.5,18.8333 102.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#3c53c7",
    d: "M 106.5,13.5 C 108.167,13.5 109.833,13.5 111.5,13.5C 111.5,19.1667 111.5,24.8333 111.5,30.5C 109.833,30.5 108.167,30.5 106.5,30.5C 106.5,24.8333 106.5,19.1667 106.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#394dc7",
    d: "M 111.5,13.5 C 113.042,14.3007 114.708,14.634 116.5,14.5C 116.5,20.1667 116.5,25.8333 116.5,31.5C 114.708,31.634 113.042,31.3007 111.5,30.5C 111.5,24.8333 111.5,19.1667 111.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#3f67c7",
    d: "M 84.5,14.5 C 84.5,20.1667 84.5,25.8333 84.5,31.5C 79.1958,33.0478 73.8625,34.3811 68.5,35.5C 68.8214,29.9738 68.4881,24.6405 67.5,19.5C 72.7815,16.854 78.4482,15.1873 84.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#3948c7",
    d: "M 116.5,14.5 C 117.833,14.8333 119.167,15.1667 120.5,15.5C 120.786,21.2586 120.452,26.9252 119.5,32.5C 118.209,32.7373 117.209,32.404 116.5,31.5C 116.5,25.8333 116.5,20.1667 116.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#3845c7",
    d: "M 120.5,15.5 C 121.609,15.5569 122.609,15.8902 123.5,16.5C 123.5,22.1667 123.5,27.8333 123.5,33.5C 122.041,33.5674 120.708,33.2341 119.5,32.5C 120.452,26.9252 120.786,21.2586 120.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78
    },
    fill: "#592dc4",
    d: "M 190.5,15.5 C 193.167,20.5 193.167,25.5 190.5,30.5C 189.167,25.5 189.167,20.5 190.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#3740c7",
    d: "M 123.5,16.5 C 125.579,16.9707 127.579,17.6373 129.5,18.5C 129.5,24.1667 129.5,29.8333 129.5,35.5C 127.102,35.7406 125.102,35.0739 123.5,33.5C 123.5,27.8333 123.5,22.1667 123.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#363cc7",
    d: "M 129.5,18.5 C 131.819,18.9925 133.819,19.9925 135.5,21.5C 134.167,25.5 134.167,29.5 135.5,33.5C 133.898,35.0739 131.898,35.7406 129.5,35.5C 129.5,29.8333 129.5,24.1667 129.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.887
    },
    fill: "#3f6cc7",
    d: "M 67.5,19.5 C 68.4881,24.6405 68.8214,29.9738 68.5,35.5C 61.3235,33.8472 59.1569,29.5138 62,22.5C 63.4877,20.84 65.321,19.84 67.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.799
    },
    fill: "#3637c6",
    d: "M 135.5,21.5 C 139.5,25.5 139.5,29.5 135.5,33.5C 134.167,29.5 134.167,25.5 135.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#4730c5",
    d: "M 161.5,26.5 C 163.615,28.8907 166.281,30.2241 169.5,30.5C 169.5,41.1667 169.5,51.8333 169.5,62.5C 166.579,62.2826 163.913,62.9493 161.5,64.5C 161.789,58.4093 161.455,52.4093 160.5,46.5C 161.833,46.1667 161.833,45.8333 160.5,45.5C 161.458,39.2564 161.791,32.923 161.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#4132c5",
    d: "M 160.5,46.5 C 161.455,52.4093 161.789,58.4093 161.5,64.5C 156.392,67.2856 153.725,71.6189 153.5,77.5C 156.167,77.5 158.833,77.5 161.5,77.5C 161.5,82.8333 161.5,88.1667 161.5,93.5C 158.167,93.5 154.833,93.5 151.5,93.5C 151.5,79.1667 151.5,64.8333 151.5,50.5C 154.382,48.8921 157.382,47.5587 160.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#542dc4",
    d: "M 180.5,48.5 C 184.542,49.8514 187.875,52.1848 190.5,55.5C 189.505,67.989 189.171,80.6557 189.5,93.5C 186.167,93.5 182.833,93.5 179.5,93.5C 179.5,88.1667 179.5,82.8333 179.5,77.5C 180.833,77.5 182.167,77.5 183.5,77.5C 183.138,73.7408 181.805,70.4075 179.5,67.5C 179.177,60.9779 179.51,54.6446 180.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#4073c6",
    d: "M 44.5,49.5 C 51.1027,51.7701 55.7694,56.1034 58.5,62.5C 58.5,72.5 58.5,82.5 58.5,92.5C 54.03,93.4861 49.3633,93.8195 44.5,93.5C 44.5,88.1667 44.5,82.8333 44.5,77.5C 45.6227,75.312 45.6227,72.9787 44.5,70.5C 44.5,63.5 44.5,56.5 44.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#4386c3",
    d: "M 14.5,50.5 C 14.5,64.8333 14.5,79.1667 14.5,93.5C 10.8183,93.6653 7.15159,93.4986 3.5,93C 1.64977,92.3103 0.316435,91.1436 -0.5,89.5C -0.5,82.8333 -0.5,76.1667 -0.5,69.5C 1.85,61.1619 6.85,54.8286 14.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#3b33c5",
    d: "M 151.5,50.5 C 151.5,64.8333 151.5,79.1667 151.5,93.5C 148.5,93.5 145.5,93.5 142.5,93.5C 142.5,82.1667 142.5,70.8333 142.5,59.5C 144.5,55.5 147.5,52.5 151.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#5a2cc4",
    d: "M 190.5,55.5 C 194.096,58.3569 196.429,62.0236 197.5,66.5C 197.5,74.8333 197.5,83.1667 197.5,91.5C 195.22,93.2227 192.553,93.8893 189.5,93.5C 189.171,80.6557 189.505,67.989 190.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.887
    },
    fill: "#3735c6",
    d: "M 142.5,59.5 C 142.5,70.8333 142.5,82.1667 142.5,93.5C 139.909,92.7457 138.076,91.079 137,88.5C 136.161,81.4333 136.494,74.4333 138,67.5C 138.754,64.3156 140.254,61.6489 142.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.829
    },
    fill: "#406ec7",
    d: "M 58.5,62.5 C 61.6153,67.8034 62.9486,73.6367 62.5,80C 62.3333,82.8333 62.1667,85.6667 62,88.5C 61.34,90.3237 60.1733,91.657 58.5,92.5C 58.5,82.5 58.5,72.5 58.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.831
    },
    fill: "#5d2ac4",
    d: "M 197.5,66.5 C 198.167,67.5 198.833,68.5 199.5,69.5C 199.5,76.1667 199.5,82.8333 199.5,89.5C 198.833,90.1667 198.167,90.8333 197.5,91.5C 197.5,83.1667 197.5,74.8333 197.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#4279c4",
    d: "M 25.5,77.5 C 31.8333,77.5 38.1667,77.5 44.5,77.5C 44.5,82.8333 44.5,88.1667 44.5,93.5C 38.1667,93.5 31.8333,93.5 25.5,93.5C 25.5,88.1667 25.5,82.8333 25.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#4830c5",
    d: "M 161.5,77.5 C 164.167,77.5 166.833,77.5 169.5,77.5C 169.5,82.8333 169.5,88.1667 169.5,93.5C 166.833,93.5 164.167,93.5 161.5,93.5C 161.5,88.1667 161.5,82.8333 161.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#4e2fc4",
    d: "M 169.5,77.5 C 172.833,77.5 176.167,77.5 179.5,77.5C 179.5,82.8333 179.5,88.1667 179.5,93.5C 176.167,93.5 172.833,93.5 169.5,93.5C 169.5,88.1667 169.5,82.8333 169.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#3d60c8",
    d: "M 95.5,105.5 C 95.5,111.167 95.5,116.833 95.5,122.5C 91.5899,126.907 91.5899,131.24 95.5,135.5C 95.5,146.833 95.5,158.167 95.5,169.5C 93.2163,169.975 91.2163,170.975 89.5,172.5C 89.5,166.167 89.5,159.833 89.5,153.5C 90.3764,153.631 91.0431,153.298 91.5,152.5C 90.7573,151.818 90.0906,151.151 89.5,150.5C 89.5,136.167 89.5,121.833 89.5,107.5C 91.4214,106.637 93.4214,105.971 95.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#3c5cc8",
    d: "M 95.5,105.5 C 97.8333,105.5 100.167,105.5 102.5,105.5C 102.5,111.167 102.5,116.833 102.5,122.5C 100.215,121.454 97.8817,121.454 95.5,122.5C 95.5,116.833 95.5,111.167 95.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#3b56c8",
    d: "M 102.5,105.5 C 103.959,105.433 105.292,105.766 106.5,106.5C 106.5,113.167 106.5,119.833 106.5,126.5C 105.527,124.861 104.194,123.527 102.5,122.5C 102.5,116.833 102.5,111.167 102.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#427fc4",
    d: "M 26.5,107.5 C 25.5214,119.42 25.1881,131.42 25.5,143.5C 19.9014,135.058 16.2347,125.724 14.5,115.5C 15.618,108.368 19.618,105.702 26.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#3c53c7",
    d: "M 106.5,106.5 C 108.403,106.796 110.07,107.463 111.5,108.5C 111.5,122.167 111.5,135.833 111.5,149.5C 110.486,150.674 109.153,151.34 107.5,151.5C 106.51,145.355 106.177,139.022 106.5,132.5C 106.5,130.5 106.5,128.5 106.5,126.5C 106.5,119.833 106.5,113.167 106.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#4d2fc4",
    d: "M 179.5,107.5 C 179.175,115.352 179.508,123.018 180.5,130.5C 178.028,137.612 174.361,143.945 169.5,149.5C 169.5,136.5 169.5,123.5 169.5,110.5C 172.085,107.083 175.418,106.083 179.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#427ac4",
    d: "M 26.5,107.5 C 27.7942,108.29 28.9609,109.29 30,110.5C 32.6292,122.244 37.4625,132.91 44.5,142.5C 44.5,149.5 44.5,156.5 44.5,163.5C 39.7599,162.279 35.9266,159.612 33,155.5C 30.2279,151.612 27.7279,147.612 25.5,143.5C 25.1881,131.42 25.5214,119.42 26.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#3e61c7",
    d: "M 89.5,107.5 C 89.5,121.833 89.5,136.167 89.5,150.5C 87.326,150.25 85.6594,149.25 84.5,147.5C 84.5,135.167 84.5,122.833 84.5,110.5C 85.8993,109.11 87.5659,108.11 89.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#522ec4",
    d: "M 179.5,107.5 C 182.676,109.179 184.343,111.846 184.5,115.5C 183.568,120.625 182.235,125.625 180.5,130.5C 179.508,123.018 179.175,115.352 179.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#394dc7",
    d: "M 111.5,108.5 C 114.109,109.443 116.109,111.11 117.5,113.5C 116.506,123.987 116.172,134.654 116.5,145.5C 115.415,147.587 113.749,148.92 111.5,149.5C 111.5,135.833 111.5,122.167 111.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.911
    },
    fill: "#3f65c7",
    d: "M 84.5,110.5 C 84.5,122.833 84.5,135.167 84.5,147.5C 74.3317,137.873 72.8317,126.873 80,114.5C 81.3712,112.959 82.8712,111.625 84.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.935
    },
    fill: "#4830c5",
    d: "M 169.5,110.5 C 169.5,123.5 169.5,136.5 169.5,149.5C 167.792,153.572 165.126,156.905 161.5,159.5C 161.826,150.983 161.493,142.65 160.5,134.5C 163.922,126.558 166.922,118.558 169.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#3948c7",
    d: "M 117.5,113.5 C 119.25,114.659 120.25,116.326 120.5,118.5C 120.5,125.833 120.5,133.167 120.5,140.5C 119.876,142.754 118.543,144.421 116.5,145.5C 116.172,134.654 116.506,123.987 117.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.764
    },
    fill: "#3845c7",
    d: "M 120.5,118.5 C 124.498,125.821 124.498,133.154 120.5,140.5C 120.5,133.167 120.5,125.833 120.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.935
    },
    fill: "#3b56c8",
    d: "M 106.5,132.5 C 106.177,139.022 106.51,145.355 107.5,151.5C 107.5,152.167 107.5,152.833 107.5,153.5C 106.511,158.975 106.178,164.642 106.5,170.5C 105.292,169.766 103.959,169.433 102.5,169.5C 102.5,158.167 102.5,146.833 102.5,135.5C 103.833,134.5 105.167,133.5 106.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#4232c5",
    d: "M 160.5,134.5 C 161.493,142.65 161.826,150.983 161.5,159.5C 158.915,162.917 155.582,163.917 151.5,162.5C 151.5,157.167 151.5,151.833 151.5,146.5C 154.512,142.462 157.512,138.462 160.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#3c5cc8",
    d: "M 95.5,135.5 C 97.8744,136.686 100.208,136.686 102.5,135.5C 102.5,146.833 102.5,158.167 102.5,169.5C 100.208,168.314 97.8744,168.314 95.5,169.5C 95.5,158.167 95.5,146.833 95.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#4174c5",
    d: "M 44.5,142.5 C 46.433,144.937 48.5997,147.271 51,149.5C 54.4576,156.856 52.2909,161.523 44.5,163.5C 44.5,156.5 44.5,149.5 44.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#3d33c5",
    d: "M 151.5,146.5 C 151.5,151.833 151.5,157.167 151.5,162.5C 146.352,159.395 145.186,155.062 148,149.5C 149.039,148.29 150.206,147.29 151.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#3e61c7",
    d: "M 89.5,153.5 C 89.5,159.833 89.5,166.167 89.5,172.5C 87.7745,174.228 86.4411,176.228 85.5,178.5C 84.508,171.018 84.1746,163.352 84.5,155.5C 86.1667,154.833 87.8333,154.167 89.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#3c53c7",
    d: "M 107.5,153.5 C 108.959,153.433 110.292,153.766 111.5,154.5C 111.791,160.923 111.458,167.256 110.5,173.5C 109.167,172.5 107.833,171.5 106.5,170.5C 106.178,164.642 106.511,158.975 107.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#394dc7",
    d: "M 111.5,154.5 C 113.674,154.75 115.341,155.75 116.5,157.5C 116.5,171.5 116.5,185.5 116.5,199.5C 114.833,199.5 113.167,199.5 111.5,199.5C 111.5,194.167 111.5,188.833 111.5,183.5C 112.5,183.5 113.5,183.5 114.5,183.5C 114.269,179.707 112.935,176.374 110.5,173.5C 111.458,167.256 111.791,160.923 111.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#3f67c7",
    d: "M 84.5,155.5 C 84.1746,163.352 84.508,171.018 85.5,178.5C 84.6993,180.042 84.366,181.708 84.5,183.5C 84.5,188.833 84.5,194.167 84.5,199.5C 80.1667,199.5 75.8333,199.5 71.5,199.5C 70.1639,197.99 68.9973,196.323 68,194.5C 64.8764,177.669 70.3764,164.669 84.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3948c7",
    d: "M 116.5,157.5 C 118.404,157.738 119.738,158.738 120.5,160.5C 120.5,173.5 120.5,186.5 120.5,199.5C 119.167,199.5 117.833,199.5 116.5,199.5C 116.5,185.5 116.5,171.5 116.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#3844c7",
    d: "M 120.5,160.5 C 121.833,161.167 122.833,162.167 123.5,163.5C 123.5,175.5 123.5,187.5 123.5,199.5C 122.5,199.5 121.5,199.5 120.5,199.5C 120.5,186.5 120.5,173.5 120.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#3740c7",
    d: "M 123.5,163.5 C 127.115,167.059 129.449,171.393 130.5,176.5C 129.167,182.833 129.167,189.167 130.5,195.5C 129.5,196.833 128.5,198.167 127.5,199.5C 126.167,199.5 124.833,199.5 123.5,199.5C 123.5,187.5 123.5,175.5 123.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.636
    },
    fill: "#373dc7",
    d: "M 130.5,176.5 C 131.75,182.877 131.75,189.21 130.5,195.5C 129.167,189.167 129.167,182.833 130.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3e61c7",
    d: "M 84.5,183.5 C 86.1667,183.5 87.8333,183.5 89.5,183.5C 89.5,188.833 89.5,194.167 89.5,199.5C 87.8333,199.5 86.1667,199.5 84.5,199.5C 84.5,194.167 84.5,188.833 84.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3d60c8",
    d: "M 89.5,183.5 C 91.5,183.5 93.5,183.5 95.5,183.5C 95.5,188.833 95.5,194.167 95.5,199.5C 93.5,199.5 91.5,199.5 89.5,199.5C 89.5,194.167 89.5,188.833 89.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3d5cc8",
    d: "M 95.5,183.5 C 97.8333,183.5 100.167,183.5 102.5,183.5C 102.5,188.833 102.5,194.167 102.5,199.5C 100.167,199.5 97.8333,199.5 95.5,199.5C 95.5,194.167 95.5,188.833 95.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3b56c8",
    d: "M 102.5,183.5 C 103.833,183.5 105.167,183.5 106.5,183.5C 106.5,188.833 106.5,194.167 106.5,199.5C 105.167,199.5 103.833,199.5 102.5,199.5C 102.5,194.167 102.5,188.833 102.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3c53c7",
    d: "M 106.5,183.5 C 108.167,183.5 109.833,183.5 111.5,183.5C 111.5,188.833 111.5,194.167 111.5,199.5C 109.833,199.5 108.167,199.5 106.5,199.5C 106.5,194.167 106.5,188.833 106.5,183.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.8c93a6454ea0f8a804ab6d8710b0f3d4.svg";
export { ForwardRef as ReactComponent };